import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SuburbOrPostalCode } from "../services/http-service/suburbOrPostalcode";

export const useGetSuburbOrPostalCode = ({ enabled, suburbOrPostalCode }: { enabled: boolean; suburbOrPostalCode: any }) => {
  const {
    isLoading: loadingSuburbOrPostalCode,
    isFetching: fetchingSuburbOrPostalCode,
    isError: errorFetchingSuburbOrPostalCode,
    data: SuburbOrPostalCodeResponse,
    error: errorSuburbOrPostalCodeResponse,
    refetch: refetchSuburbOrPostalCode,
  } = useQuery({
    queryKey: ["suburbOrPostalCode"],
    queryFn: async () => await SuburbOrPostalCode(suburbOrPostalCode),
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });
  const fetchSuburbOrPostalCodeError = (errorSuburbOrPostalCodeResponse as AxiosError)?.response?.data;

  return {
    loadingSuburbOrPostalCode,
    fetchingSuburbOrPostalCode,
    errorFetchingSuburbOrPostalCode,
    SuburbOrPostalCodeResponse,
    fetchSuburbOrPostalCodeError,
    refetchSuburbOrPostalCode,
  };
};
